import { Button, TypographyDetail } from '@seen/ui'
import type { ReactNode } from 'react'
import { Popover } from '#src/components/core/popover/Popover.tsx'
import { PopoverContent } from '#src/components/core/popover/PopoverContent.tsx'
import { PopoverTrigger } from '#src/components/core/popover/PopoverTrigger.tsx'
import { DisplayButton } from '#src/components/DisplayButton.tsx'
import { DisplayPropertyButton } from '#src/components/DisplayPropertyButton.tsx'
import type { ParticipantViewDisplay } from '#src/pages/participants/useParticipantsPageStore.ts'

export function DisplayEditor({
  value,
  onChange,
  isDirty,
  onReset,
}: {
  value: ParticipantViewDisplay
  onChange: React.Dispatch<
    React.SetStateAction<Partial<ParticipantViewDisplay>>
  >
  isDirty: boolean
  onReset: () => void
}): ReactNode {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <DisplayButton showIndicator={isDirty} />
      </PopoverTrigger>
      <PopoverContent className="p-0 py-2">
        <div className="flex flex-col text-xs">
          <div className="flex px-4 py-2">
            <label className="flex-1">
              <TypographyDetail>Ordering</TypographyDetail>
            </label>
            <select
              value={value.ordering}
              onChange={(e) =>
                onChange((currDisplay) => ({
                  ...currDisplay,
                  ordering: e.target
                    .value as ParticipantViewDisplay['ordering'],
                }))
              }
            >
              <option value="name">Name</option>
              <option value="enrollment-date">Enrollment date</option>
            </select>
          </div>
          <div className="flex flex-col gap-2 border-t-[0.5px] px-4 pt-4 pb-2">
            <label>
              <TypographyDetail>Display properties</TypographyDetail>
            </label>
            <div className="flex flex-wrap gap-1">
              <DisplayPropertyButton
                isSelected={value.showBirthDate}
                onClick={() => {
                  onChange((currDisplay) => ({
                    ...currDisplay,
                    showBirthDate: !value.showBirthDate,
                  }))
                }}
              >
                Birth date
              </DisplayPropertyButton>
              <DisplayPropertyButton
                isSelected={value.showPhoneNumber}
                onClick={() => {
                  onChange((currDisplay) => ({
                    ...currDisplay,
                    showPhoneNumber: !value.showPhoneNumber,
                  }))
                }}
              >
                Phone number
              </DisplayPropertyButton>
              <DisplayPropertyButton
                isSelected={value.showMRN}
                onClick={() => {
                  onChange((currDisplay) => ({
                    ...currDisplay,
                    showMRN: !value.showMRN,
                  }))
                }}
              >
                MRN
              </DisplayPropertyButton>
              <DisplayPropertyButton
                isSelected={value.showEnrollmentDate}
                onClick={() => {
                  onChange((currDisplay) => ({
                    ...currDisplay,
                    showEnrollmentDate: !value.showEnrollmentDate,
                  }))
                }}
              >
                Enrollment date
              </DisplayPropertyButton>
              <DisplayPropertyButton
                isSelected={value.showLabels}
                onClick={() => {
                  onChange((currDisplay) => ({
                    ...currDisplay,
                    showLabels: !value.showLabels,
                  }))
                }}
              >
                Labels
              </DisplayPropertyButton>
            </div>
          </div>
          {isDirty && (
            <div className="flex justify-end border-t-[0.5px] px-2 pt-2">
              <Button variant="ghost" size="xs" onClick={onReset}>
                Reset
              </Button>
            </div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  )
}
